import {
  AreaFragmentFragment,
  BoundingBoxInput,
  LocationShapeFragmentFragment
} from '@lopo-tech/lopo-api'
import { IAddress } from 'src/interfaces/address'
import { ILocationShape } from 'src/interfaces/location'

export const cleanShapeObject = <T extends ILocationShape>(value: T): ILocationShape => {
  // clean unneeded values
  return {
    id: value.id,
    boundingBox: value.boundingBox,
    center: value.center,
    name: value.name,
    slug: value.slug
  }
}

// the API schema allows a cluster without center and bounding box, and without them it cannot be the app location
export const toAppLocation = (area: AreaFragmentFragment): ILocationShape | undefined => {
  if (!area.center || !area.boundingBox) {
    return undefined
  }
  return cleanShapeObject({ ...area, center: area.center, boundingBox: area.boundingBox })
}

export const createDateAddress = (
  street?: string | null | undefined,
  cityWithDistrict?: string | null | undefined
): string => {
  return street && cityWithDistrict
    ? `${street}, ${cityWithDistrict}`
    : cityWithDistrict || ''
}

export const formatAddress = (address: IAddress) => {
  return createDateAddress(address.street, address.locationShape.name)
}

export const boundingBoxToBoundingBoxInput = (
  box?: LocationShapeFragmentFragment['boundingBox']
): BoundingBoxInput | undefined =>
  box
    ? {
      northEast: {
        latitude: box.northEast.latitude,
        longitude: box.northEast.longitude
      },
      southWest: {
        latitude: box.southWest.latitude,
        longitude: box.southWest.longitude
      }
    }
    : undefined
